import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/recruitment-management-systems/reporting-and-analytics/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "reporting-and-analytics" entry is kept); the seo block below is a fallback.

export const reportingAndAnalytics: ContentPage = {
  slug: "recruitment-management-systems/reporting-and-analytics",
  template: "hrmsFeature",
  seo: {
    title: "Transform Recruitment with Data Analytics",
    description: "Enhance your recruitment with advanced analytics, real-time data, customizable dashboards, and predictive tools for optimized hiring strategies.",
    keywords: [
      "recruitment analytics",
      "HR data reporting",
      "predictive hiring analytics",
      "recruitment dashboard",
      "real-time recruitment data.",
    ],
    ogImage: "/assets/data/seoimages/reporting-and-analytics.webp",
  },
  leaf: {
    hero: {
      caption: "Reporting and Analytics",
      title: "Leverage Data with Advanced Reporting and Analytics",
      description: "Utilize powerful analytics and customized reports to gain insights into your recruitment process, improving decision-making and strategy.",
      h1: "caption",
    },
    split: {
      title: "Data-Driven Recruitment Insights",
      bullets: [
        { title: "Customizable Recruitment Dashboards", description: "Create personalized views of essential recruitment metrics." },
        { title: "Real-Time Data Reporting", description: "Access up-to-date information on recruitment activities." },
        { title: "Predictive Recruitment Analytics", description: "Forecast hiring needs based on current and historical data." },
        { title: "Key Metric Tracking", description: "Monitor time-to-fill, cost-per-hire, and more." },
      ],
      image: "/assets/images/img/product/hrms/recruitmentms/reporting-and-analytics_info.webp",
      imageAlt: "reporting-and-analytics_info",
    },
    cardsHeading: {
      title: "Key Features of Recruitment Management System",
      description: "Optimize Recruitment Management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Multi-Platform Job Posting",
        href: "/hrms-software/recruitment-management-systems/multi-platform-job-posting/",
        description: "Expand your talent search by posting jobs simultaneously across multiple job boards and social media platforms with a single click.",
        image: "/assets/images/img/product/hrms/recruitmentms/multi-platform-job-posting.webp",
        imageAlt: "multi-platform-job-posting",
      },
      {
        title: "Resume Parsing",
        href: "/hrms-software/recruitment-management-systems/resume-parsing/",
        description: "Extract and analyze candidate information efficiently with our AI-driven resume parsing technology, speeding up the recruitment process.",
        image: "/assets/images/img/product/hrms/recruitmentms/resume-parsing.webp",
        imageAlt: "resume-parsing",
      },
      {
        title: "Candidate Communication",
        href: "/hrms-software/recruitment-management-systems/candidate-communication/",
        description: "Keep candidates informed and engaged throughout the recruitment process with automated, personalized communication tools.",
        image: "/assets/images/img/product/hrms/recruitmentms/candidate-communication_image.webp",
        imageAlt: "candidate-communication",
      },
      {
        title: "Interview Management",
        href: "/hrms-software/recruitment-management-systems/interview-management/",
        description: "Coordinate and manage candidate interviews efficiently with our comprehensive interview management system, optimizing recruitment.",
        image: "/assets/images/img/product/hrms/recruitmentms/interview-management_image.webp",
        imageAlt: "interview-management",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Transform Your Recruitment with Data Insights!",
    relatedBlogsKeyword: "reporting-and-analytics-blog,reducing-time-to-hire,hr-tech-trends-recruitment",
    metaKey: "reporting-and-analytics",
  },
  sections: [],
};
